const $ = jQuery.noConflict();

'use strict';
const Option = {

	$domOptionSelect: $('.js-option-select'),

	init: function() {
		this.selectOption();
	},

	selectOption: function() {
		$('.js-option-select').on('click', function() {
			$('.js-option-select').removeClass('is-active');
			$(this).addClass('is-active');
		});
	}
};

export default Option;
